

import React from 'react';
import './index.scss';
import classnames from 'classnames'
function ComBtn({
    info,
    handleBtn
}) {
    return (
        <div 
            className = {classnames('list-btn', info.btnSty)} 
            onClick = {handleBtn}
            clstag = {info.btnCls}
            data-qidian-ext={JSON.stringify({missionid: info.taskCode})}          
            >{info.btnText}</div>
       
    )
}

export default React.memo(ComBtn);